import { Filter } from './filter.model';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';


@Injectable()
export class A2matFiltersService {

  constructor(
    private translateService: TranslateService,
  ){

  }

  setSelection(filter:Filter, selection){
    filter.selected = selection;
    filter.selected.value = filter.selected.value ?? filter.selected.id;
    const filterName = this.translateService.instant(filter.name);
    filter.selected.display = `${filterName}: ${filter.selected.label}`;
  }
}
